import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import isEqual from 'lodash.isequal';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useTranslation } from 'react-i18next';
import omit from 'lodash.omit';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
const NameListTableData = _ref => {
  let {
    isSaved,
    notSavedStyle,
    body,
    setBody,
    saveData,
    rowData,
    uploadFile,
    deleteData,
    data,
    uploadAllowed,
    setUploadAllowed,
    createNewData,
    removeEmptyRow,
    emptyRowId
  } = _ref;
  const [file, isFileUploadLoading, setFile] = useFileUpload(!!body.id ? uploadFile : createNewData, 'document', uploadAllowed);
  const {
    t
  } = useTranslation();
  const submit = () => {
    if (!!rowData.id) {
      saveData(body);
    } else if (!file) {
      createNewData(new FormData());
    } else {
      setUploadAllowed(true);
    }
  };
  const changeBody = e => {
    const key = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const finalValue = ['rel_agreed_annual_working_hrs'].includes(key) && !!value.length ? Number(value) : value;
    if ((e.target.type === 'checkbox' || key === 'year') && !!rowData.id) {
      if (key === 'fulltime' && value === true) {
        //reset specific data to original when fulltime is checked
        const fulltimeBody = {
          ...body,
          [key]: finalValue
        };
        saveData(fulltimeBody);
        setBody({
          ...fulltimeBody
        });
      } else {
        saveData({
          ...body,
          [key]: finalValue
        });
        setBody({
          ...body,
          [key]: finalValue
        });
      }
      return;
    }
    setBody({
      ...body,
      [key]: finalValue
    });
  };
  const filenameLink = rowData.document ? /*#__PURE__*/React.createElement("a", {
    href: rowData.document.url,
    target: "_blank",
    rel: "noreferrer"
  }, rowData.document.filename) : /*#__PURE__*/React.createElement("p", null, t('no_file_has_been_uploaded'));
  const saveOnBlur = () => {
    submit();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    style: isSaved ? {} : notSavedStyle
  }, /*#__PURE__*/React.createElement(Form.Control, {
    onBlur: saveOnBlur,
    value: body.employee_name_number,
    name: "employee_name_number",
    onChange: changeBody,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
    style: {
      width: '150px'
    },
    as: "select",
    name: "year",
    onChange: changeBody,
    size: "md",
    value: body.year
  }, /*#__PURE__*/React.createElement("option", {
    key: 'year_after_name',
    value: 'after_30_06_2020'
  }, t('after_30_06_2020')), /*#__PURE__*/React.createElement("option", {
    key: 'year_before_name',
    value: 'before_01_07_2020'
  }, t('before_01_07_2020')))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "bda",
    checked: body.bda,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "fulltime",
    checked: body.fulltime,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "digital_record",
    disabled: body.fulltime,
    checked: body.fulltime ? false : body.digital_record,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 1,
    onChange: changeBody,
    object: body?.calculations,
    name: "share_of_working_time",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true,
    suffix: '%'
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    onBlur: saveOnBlur,
    object: body,
    name: "rel_agreed_annual_working_hrs",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: body.fulltime
  })), /*#__PURE__*/React.createElement("td", null, filenameLink), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      marginRight: '8px'
    },
    onClick: () => emptyRowId !== null ? removeEmptyRow(emptyRowId) : deleteData(body, data),
    "data-testid": "delete_button"
  }))));
};
export default NameListTableData;